var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stacked-column-chart-component"},[(_vm.series[0].data.length)?_c('vue-apex-charts',{ref:"chart",attrs:{"type":"bar","height":_vm.height || 400,"options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }